export function initProgressBar() {
    const bar = document.getElementById('gh-progress-bar');
    if (!bar) return;

    const content = document.querySelector('.gh-post-content');
    if (!content) return;

    function updateProgress() {
        const { top, height } = content.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        // Progress is 0 when article top is at viewport top, 1 when article bottom reaches viewport bottom
        const scrolled = Math.max(0, Math.min(1, -top / (height - viewportHeight)));
        bar.style.width = (scrolled * 100) + '%';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
}
